import useSeo from "@/lib/useSeo";
import PageHero from "@/components/site/PageHero";
import Contact from "@/components/sections/Contact";

export default function Kontakt() {
    useSeo({
        title: "Kontakt – Alpen Reinigung Innsbruck (Faisal Safi)",
        description:
            "Kontakt zu Alpen Reinigung in Innsbruck: Telefon +43 676 7092658, E-Mail info@alpen-reinigung.at oder Kontaktformular. Wir melden uns innerhalb eines Werktags.",
        path: "/kontakt",
    });
    return (
        <div>
            <PageHero
                eyebrow="Kontakt"
                title="Kontakt zu Alpen Reinigung"
                lead="Wir freuen uns über Ihre Anfrage. Telefon ist am schnellsten – alternativ schreiben Sie uns hier. Antwort in der Regel innerhalb eines Werktags."
                breadcrumbs={[{ label: "Kontakt" }]}
            />
            <Contact />
        </div>
    );
}
